export default "__VITE_ASSET__UfX9uybp__"